module.exports = __webpack_public_path__ + "static/media/mohsin.73f27c7b.jpeg";